import * as React from "react";
import { Switch, Route } from "react-router-dom";

import { NotFound, Box } from "../../../components";
import { MainLayout } from "../../../layouts";

import SideNav from "./NavContainer";
import Terms from "./Terms";
import Privacy from "./Privacy";
import QA from "./QA";
import Order from "./Order";
import About from "./About";
import "./StaticPages.css";

const StaticPages = props => (
  <MainLayout className="static-pages" separateChildren>
    <section className="content">
      <Box hasShadow fullContainer>
        <div className="row content__container">
          <div className="col-md-4 content__left">
            <SideNav />
          </div>
          <div className="col-md-8 content__right">
            <div className="tab-content">
              <Switch>
                <Route path="/pages/about" component={About} />
                <Route path="/pages/terms" component={Terms} />
                <Route path="/pages/privacy" component={Privacy} />
                <Route path="/pages/qa" component={QA} />
                <Route path="/pages/order" component={Order} />
                <Route component={NotFound} />
              </Switch>
            </div>
          </div>
        </div>
      </Box>
    </section>
  </MainLayout>
);

export default StaticPages;



// WEBPACK FOOTER //
// ./src/routes/StaticPages/components/StaticPages.tsx